module.exports = __webpack_public_path__ + "img/banner-pet.f093772c.jpg";